<template>
	<div class="loadItem">
		<div class="loadHead">
			<div class="title">
				<div class="text">Files</div>
				<button @click="onGuide" type="button" class="mainBtn mainBtn-text">
					<span class="btnIco"><svg-sprite icon-id="attention" width="20" height="20"></svg-sprite></span>
				</button>
			</div>

		</div>

		<div class="loadMain">
			<div class="tebleWrapper" v-if="load.file.length > 0 && !isListItems">
				<main-table
						padding="0"
						:flag="flag"
						:headers="getHeaders"
						:listItems="getListItems"
						@updateClickButtonItemIndex="onlickButtonItemIndex($event)"
						@updateClickButton="onClickButton($event, flag)"
						:is-hide-header="false"
						:items-per-page-amount="10"
						:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				></main-table>
			</div>

			<div class="fileRow">
				<field
						margin="0"
						label="Confirmation"
						placeholder="Add file"
						@updateFile="setNewItem($event, 1, 'Confirmation')"
						is-file
						is-readonly
				></field>
				<field
						margin="0"
						label="BOL"
						placeholder="Add file"
						@updateFile="setNewItem($event, 2, 'BOL')"
						is-file
						is-readonly
				></field>
				<field
						margin="0"
						label="Other"
						placeholder="Add file"
						@updateFile="setNewItem($event, 3, 'Other')"
						is-file
						is-readonly
				></field>
			</div>
		</div>
	</div>
</template>

<script>
// Constants
import { PAGE } from "@/constants/constants";
import { tableFiles } from "@/components/Dispatch/Trips/DialogTrip/constants";

// helpers

export default {
	name: "Files",
	props: {
		load: Object,
		typeBilling: [ String, Number ],
	},
	watch: {
		typeBilling(val, oldVal) {
			if (val !== oldVal) {
				this.getHeaders;
			}
		},
	},
	computed: {
		getHeaders() {
			const copyTableFiles = tableFiles.slice();
			if (this.typeBilling !== "") {
				return copyTableFiles.map(item => {
					if (Array.isArray(item.buttons)) {
						const deleteButton = item.buttons.find(button => button.value === 'delete');
						if (deleteButton) {
							deleteButton.perm = false;
						}
					}
					return item;
				});
			} 
			return copyTableFiles.map(item => {
				if (Array.isArray(item.buttons)) {
					const deleteButton = item.buttons.find(button => button.value === 'delete');
					if (deleteButton) {
						deleteButton.perm = true;
					}
				}
				return item;
			});
		},
		getListItems() {
			return this.load.file.filter(obj => obj.status !== 'deleted');
		},
		isListItems() {
			return this.load.file.every(file => file.status === 'deleted');
		},
	},
	data() {
		return {
			flag: PAGE.TRIP_FILES,
			list: null,
			index: null,
		};
	},
	methods: {
		onGuide() {
			this.$emit('updateGuide', this.flag);
		},
		onlickButtonItemIndex(index) {
			this.index = index;
		},
		onClickButton({ key, item }, nameComponent) {
			this.$emit('updateEditItem', { key, item, itemIndex: this.index, nameComponent });
		},
		setNewItem(e, id, name) {
			this.$emit('updateNewItem', { e, id, name });
		},
	},
};
</script>
<style lang="scss">
.loadMain {
	.pagination {
		padding: 20px 0 10px;
	}
}
</style>
<style scoped lang="scss">
@import "../loadItem";
.fileRow {
	margin-top: 20px;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: 10px;
}
</style>
